import { Component } from '@angular/core';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  standalone: false,
  styleUrl: './features.component.scss'
})
export class FeaturesComponent {}
